import { API_BASE } from "../../config/api";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar";

export default function AdminDashboard() {
  const [tests, setTests] = useState([]);
  const navigate = useNavigate();

  // ================= LOAD ALL TESTS (ADMIN) =================
  const loadTests = () => {
    fetch(`${API_BASE}/admin/tests`, {
      credentials: "include", // ✅ cookie auto send
    })
      .then((res) => res.json())
      .then((data) => setTests(data))
      .catch((err) => console.error("Fetch error:", err));
  };

  useEffect(() => {
    loadTests();
  }, []);

  // ================= LAUNCH / UNLAUNCH =================
  const toggleLaunch = async (testId) => {
    try {
      const res = await fetch(
        `${API_BASE}/admin/tests/${testId}/launch`,
        {
          method: "POST",
          credentials: "include", // ✅ cookie
        }
      );

      const data = await res.json();

      setTests((prev) =>
        prev.map((test) =>
          test._id === testId
            ? { ...test, isLaunched: data.isLaunched }
            : test
        )
      );
    } catch (err) {
      console.error("Launch error:", err);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-900 text-white">
      {/* ================= SIDEBAR ================= */}
      <aside className="w-64 bg-gray-800 border-r border-gray-700 p-6">
        <h2 className="text-2xl font-bold text-purple-400 mb-8">
          CodeViva Admin
        </h2>

        <nav className="space-y-4">
          <button className="w-full text-left px-4 py-2 rounded-lg bg-purple-600 font-semibold">
            📋 Tests
          </button>

          <button
            onClick={() => navigate("/admin/create-test")}
            className="w-full text-left px-4 py-2 rounded-lg hover:bg-gray-700"
          >
            ➕ Create Test
          </button>

          <button className="w-full text-left px-4 py-2 rounded-lg hover:bg-gray-700">
            📊 Results
          </button>

          <button className="w-full text-left px-4 py-2 rounded-lg hover:bg-gray-700">
            ⚙️ Settings
          </button>
        </nav>
      </aside>

      {/* ================= MAIN CONTENT ================= */}
      <div className="flex-1 flex flex-col">
        <Topbar title="Admin Panel – Tests" />

        <main className="flex-1 p-8">
          {tests.length === 0 && (
            <p className="text-gray-400">No tests found</p>
          )}

          <div className="grid gap-5">
            {tests.map((test) => (
              <div
                key={test._id}
                className="bg-gray-800 border border-gray-700
                p-6 rounded-xl flex flex-col md:flex-row
                md:items-center md:justify-between gap-4
                hover:border-purple-500 transition"
              >
                {/* LEFT */}
                <div>
                  <p className="text-xl font-semibold">
                    {test.title}
                  </p>
                  <p className="text-sm text-gray-400">
                    ⏱ Duration: {test.duration} minutes
                  </p>
                  <p className="text-sm mt-2">
                    Status:{" "}
                    <span
                      className={
                        test.isLaunched
                          ? "text-green-400 font-semibold"
                          : "text-red-400 font-semibold"
                      }
                    >
                      {test.isLaunched
                        ? "Launched"
                        : "Not Launched"}
                    </span>
                  </p>
                </div>

                {/* RIGHT ACTIONS */}
                <div className="flex gap-3 flex-wrap">
                  <button
                    onClick={() =>
                      navigate(`/admin/tests/${test._id}`)
                    }
                    className="bg-blue-600 hover:bg-blue-700
                    px-4 py-2 rounded-lg text-sm font-semibold"
                  >
                    Add Questions
                  </button>

                  <button
                    onClick={() =>
                      window.open(
                        `${API_BASE}/admin/tests/${test._id}/report`,
                        "_blank"
                      )
                    }
                    className="bg-green-600 hover:bg-green-700
                    px-4 py-2 rounded-lg text-sm font-semibold"
                  >
                    Download Excel
                  </button>

                  <button
                    onClick={() => toggleLaunch(test._id)}
                    className={`px-4 py-2 rounded-lg text-sm font-semibold ${
                      test.isLaunched
                        ? "bg-red-600 hover:bg-red-700"
                        : "bg-purple-600 hover:bg-purple-700"
                    }`}
                  >
                    {test.isLaunched
                      ? "Unlaunch Test"
                      : "Launch Test"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
